module.exports = __webpack_public_path__ + "img/yyjjfa_01.9c3457a2.jpg";